import styled from "styled-components";

export const ActionContainer = styled.div`
  background-color: var(--one-color-background-base-1);
  margin-bottom: 25px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  background-color: var(--one-color-cobas-gray-50);
`;

export const ContentContainerInside = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px;
  background: var(--one-color-cobas-white);
  justify-content: flex-start;
`;
